import { isEmptyScObj } from "../../utils/siteUtils";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import React, { useCallback, useEffect, useState } from "react";
import Checkbox from "../../elements/checkbox";
import PrimaryButton from "../../elements/primary-button";
import { selectUserState } from "../../selectors/application";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
import { getUserInfo, sendResetPasswordLinkToEmail } from "../../services/userService";
import { setUserInfoAction } from "../../redux/actions";
import FillPhoneNumberModal from "../../react-components/fill-phone-number-modal";
import ChangePhoneNumberModal from "../../react-components/change-phone-number-modal";
import ResetPassword from "../../components/ResetPassword";
import { S_AUTH_TOKEN, S_LANG, webStorage } from "../../utils/webStorage";

function AccountNewsletterSetting(props) {
  if (isEmptyScObj(props)) {
    return null;
  } else {
    return <AccountNewsletterSettingMain {...props} />;
  }
}
function AccountNewsletterSettingMain(props) {
  /*Redux start*/
  const dispatch = useDispatch();
  const user = useSelector(selectUserState);
  const setUserInfo = payload => dispatch(setUserInfoAction(payload));
  /*Redux end*/
  const lang = webStorage.get(S_LANG);
  const {
    fields: { headingType, headingBody, body, checkbox, button, consent, sendBySMS, saveSuccessMessage, saveFailedMessage, bindNewsletterError, fillPhoneNumberModal, changePhoneNumberModal, resetPassword }
  } = props;
  const [phoneArea, setPhoneArea] = useState(null);
  const [phone, setPhone] = useState(null);
  const [updateMessage, setUpdateMessage] = useState(null);
  const [fillPhoneNumberOpened, setFillPhoneNumberOpened] = useState(false);
  const [changePhoneNumberOpened, setChangePhoneNumberOpened] = useState(false);
  const [resetPasswordOpened, setResetPasswordOpened] = useState(false);
  // const [wantsNewsletter, setWantsNewsletter] = useState(checkbox?.checked);
  // const [
  //   changeNewsletterPreferencesButtonIsDisabled,
  //   setChangeNewsletterPreferencesButtonIsDisabled
  // ] = useState(true);
  let checkboxesProps = [];
  if (checkbox) {
    checkboxesProps.push({
      id: "emailSubscribed",
      showError: false,
      type: "checkbox",
      disabled: checkbox?.fields?.disabled.value,
      checked: checkbox?.fields?.checked.value,
      label: checkbox?.fields?.label.value,
      infoText: checkbox?.fields?.infoText.value
    });
  }
  if (sendBySMS) {
    checkboxesProps.push({
      id: "smsSubscribed",
      showError: false,
      type: "checkbox",
      disabled: sendBySMS?.fields?.disabled.value,
      checked: sendBySMS?.fields?.checked.value,
      label: sendBySMS?.fields?.label.value,
      infoText: sendBySMS?.fields?.infoText.value
    });
  }
  const [selectedBrandMarketing, setSelectedBrandMarketing] = useState(
    checkboxesProps.map(box => {
      return { label: box.label, id: box.id, checked: box.checked };
    })
  );
  const [changeBrandMarketingButtonIsDisabled, setChangeBrandMarketingButtonIsDisabled] = useState(true);

  useEffect(() => {
    let checkboxes = checkboxesProps.map(box => {
      box.checked = user[box.id] ? Boolean(Number(user[box.id])) : box?.checked;
      return box;
    });
    setSelectedBrandMarketing(checkboxes);
  }, [user]);
  const onBrandMarketingChanged = (index, checked) => {
    let selectedCopy = selectedBrandMarketing;
    selectedCopy[index].checked = checked;
    setSelectedBrandMarketing(selectedCopy);
    setChangeBrandMarketingButtonIsDisabled(false);
    setUpdateMessage(null);
  };
  const onSubmitBrandMarketingChange = async evt => {
    const isSmsSubscribeChecked = (selectedBrandMarketing || []).some(box => box.id === "smsSubscribed" && box.checked);
    if (isSmsSubscribeChecked && !user?.mobileNo) {
      setFillPhoneNumberOpened(true);
      return null;
    }
    await saveBrandMarketingChange(user?.mobileNoCountryCode, user?.mobileNo);
  };
  const saveBrandMarketingChange = async (phoneArea, phone) => {
    let emailSubscribed = Boolean(Number(user?.emailSubscribed));
    let brandMarketing = {};
    (selectedBrandMarketing || []).forEach(item => {
      brandMarketing[item.id] = item.checked ? "1" : "0";
    });
    if (!emailSubscribed && selectedBrandMarketing[0].checked) {
      try {
        await bindNewsletter();
      } catch (err) {
        setUpdateMessage(bindNewsletterError?.value);
        return;
      }
    }
    try {
      await api.user.update(null, {
        ...user,
        ...brandMarketing,
        mobileNo: phone,
        mobileNoCountryCode: phoneArea
      });
      const userInfo = await getUserInfo();
      setUserInfo(userInfo);
      setUpdateMessage(saveSuccessMessage.value);
    } catch (ex) {
      setUpdateMessage(saveFailedMessage.value);
    }
    setChangeBrandMarketingButtonIsDisabled(true);
    setUpdateMessage(saveSuccessMessage.value);
  };
  const bindNewsletter = async () => {
    const consentNo = consent ? consent.id : "";
    const countryId = user.preferredCountryId;
    const body = {
      isSubscriptionFlag: "1",
      receiver: user.email,
      contentMap: {},
      email: user.email,
      countryId: countryId,
      consentCode: consentNo
    };
    return api.bind(null, body);
  };
  const fillPhoneNumberModalProps = {
    ...fillPhoneNumberModal,
    phoneArea,
    setPhoneArea,
    phone,
    setPhone,
    open: fillPhoneNumberOpened,
    onCloseClicked() {
      setFillPhoneNumberOpened(false);
    },
    onFilled({ phone, phoneArea }) {
      setPhone(phone);
      setPhoneArea(phoneArea);
      setFillPhoneNumberOpened(false);
      setChangePhoneNumberOpened(true);
    }
  };
  const changePhoneNumberProps = {
    lang: lang,
    user: user,
    open: changePhoneNumberOpened,
    phoneAreaEntered: phoneArea,
    phoneNumberEntered: phone,
    ...changePhoneNumberModal?.fields?.modalChangePhoneNumber,
    onForgetPassword() {
      setChangePhoneNumberOpened(false);
      setResetPasswordOpened(true);
    },
    onCloseClicked: evt => {
      setChangePhoneNumberOpened(false);
    },
    onUpdateSuccess: async (evt, phoneArea, phone) => {
      setChangePhoneNumberOpened(false);
      await saveBrandMarketingChange(phoneArea, phone);
    }
  };
  const resetPasswordProps = {
    open: resetPasswordOpened,
    onCloseClicked() {
      setResetPasswordOpened(false);
    },
    isInConfirmationStep: false,
    sendResetPasswordLink: async (evt, data) => {
      await sendResetPasswordLinkToEmail(lang, data.email);
    },
    ...resetPassword
  };
  return (
    <div className="section">
      <Heading type={headingType} typographyClass="type-h3" html={headingBody} />
      <BodyText html={body.value} className="form-section-builder-section-body" />
      <div className="areas-of-interest-checkbox-contianer">
        {(selectedBrandMarketing || []).map((box, index) => {
          return (
            <Checkbox
              {...{
                ...box,
                onChange: checked => onBrandMarketingChanged(index, checked)
              }}
              key={index}
            />
          );
        })}
      </div>
      {updateMessage && <BodyText html={updateMessage} />}

      <PrimaryButton
        {...{
          colorScheme: button?.fields?.colorScheme,
          iconName: button?.fields?.iconName,
          buttonText: button?.fields?.buttonText?.value,
          isDisabled: changeBrandMarketingButtonIsDisabled,
          callback: evt => onSubmitBrandMarketingChange()
        }}
      />
      <FillPhoneNumberModal {...fillPhoneNumberModalProps} />
      {changePhoneNumberModal && <ChangePhoneNumberModal {...changePhoneNumberProps} />}

      {resetPassword && <ResetPassword {...resetPasswordProps} />}
    </div>
  );
}
export default AccountNewsletterSetting;
